<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">Possible Errors</h1>
      <p>
        There are certain scenarios under which the analysis cannot be performed. The most common failure scenario is when
        KPIs do not contain crucial data required for the analysis to run. In that case, the following error screen
        will appear:
      </p>

      <div class="image-container">
        <img src="@/images/manual/faulty-sii-analysis.png" alt="faulty analysis run">
        <div class="img-caption">Figure 9. Faulty analysis, with an error message.</div>
      </div>

      <p>
        Specifically for SII & SPI Analysis, the project is automatically scanned in the background and the corresponding
        analysis button, in almost all cases, informs the user for the result of the analysis (faulty/healthy).
        When the button is <b><span class="text-blue">blue</span> it means that the project is healthy, while when it is
        <span class="text-red">red with an <i class="fas fa-warning" /> exclamation mark</span> it means that the
        project is faulty</b>.
      </p>

      <div class="image-container">
        <v-row>
          <v-col>
            <img src="@/images/manual/sii-analysis-button-red.png" alt="red and blue analysis buttons">
          </v-col>
          <v-col>
            <img src="@/images/manual/sii-analysis-button-blue.png" alt="red and blue analysis buttons">
          </v-col>
        </v-row>
        <div class="img-caption">Figure 10. Red and blue analysis buttons.</div>
      </div>

      <p>
        The red button will provide an explanation of the errors and in which Aggregation Level they exist. An error
        could exist in either a Sector and/or a Dimension. In more detail, sectors and dimensions must sum up to
        exactly 1.0 (the tolerance is 0.001, so 1.001 and 0.999 are also accepted). This must be true for all the
        sectors and dimensions of each aggregation level.
      </p>

      <div class="image-container">
        <img src="@/images/manual/explanatory-analysis-message-button.png" style="height: 66%; width: 66%" alt="explanatory message">
        <div class="img-caption">Figure 11. Explanatory message shown from the button</div>
      </div>

      <p>
        Another possible and common scenario, is that the <b>Dimension/Sector weights were never provided in the uploaded CSV file</b>.
        To check if that is the case, users can visit the 'Show' page of a random KPI and examine if there are values assigned to the values
        of the Sectors/Dimensions.
      </p>

      <div class="image-container">
        <img src="@/images/manual/empty-sector-weights.png" alt="unassigned weights">
        <div class="img-caption">Figure 12. KPIs with unassigned weights</div>
      </div>

      <p>
        When all the problems are solved with the weights, the analysis button will turn blue.
      </p>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>